import { render, staticRenderFns } from "./PolicyServicingHeader.vue?vue&type=template&id=0525da8f"
import script from "./PolicyServicingHeader.vue?vue&type=script&lang=js"
export * from "./PolicyServicingHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports